export default function createAuthCodeLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `auth-code:${input.type}` });
    return {
        requested(purpose, accountId) {
            return log({
                type: "requested",
                details: { purpose, accountId },
            });
        },
        created(accountId) {
            return log({
                type: "created",
                details: { accountId },
            });
        },
        received(accountId, sender) {
            return log({
                type: "received",
                details: { accountId, sender },
            });
        },
    };
}
